module.exports = __webpack_public_path__ + "static/media/app_logo.5c8c430a.png";